/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class ClientChatComponent extends Component {
  @service twoWayChat;
  @tracked message = '';

  get smsCount() {
    return Math.ceil(this.message.length / this.perMessageLimit);
  }

  get perMessageLimit() {
    return /\p{Extended_Pictographic}/u.test(this.message) ? 70 : 160;
  }

  @action
  sendMessage() {
    this.twoWayChat.sendMessageTask.perform(this.message);
    this.message = '';
  }
}
